export default "__VITE_ASSET__B$fAesbk__"